<template>
  <div
    class="history-table-border flex h-10 w-fit-content rounded-t border-t border-r border-l"
  >
    <div
      v-for="(tab, index) in HISTORY_TABLE_TABS"
      :key="tab"
      class="flex cursor-pointer items-center justify-center px-5 font-medium"
      :class="{
        'border-r': index !== HISTORY_TABLE_TABS.length - 1,
        'bg-blue-50 text-blue-600': modelValue === tab,
      }"
      data-cy="do-history-tab"
      @click="$emit('update:modelValue', tab)"
    >
      {{ tab }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

defineEmits<{
  (eventName: "update:modelValue", value: string): void;
}>();

defineProps({
  modelValue: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

const HISTORY_TABLE_TABS = [
  t("ORCHESTRATION.CONDITION_MET"),
  t("ORCHESTRATION.CONDITION_NOT_MET"),
  t("COMMON.ALL"),
];
</script>
